import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type HTMLAttributes } from 'vue';
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    defaultValue: { type: Boolean },
    modelValue: { type: Boolean },
    id: {},
    label: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emits = __emit;

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });

    const label = computed(() => {
        return props.label ? t(props.label) : '';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Label), {
    for: _ctx.id,
    class: _normalizeClass(_unref(cn)('flex cursor-pointer items-center justify-self-start', props.class))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Checkbox), {
        modelValue: _unref(modelValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
        "data-slot": "checkbox",
        id: _ctx.id
      }, null, 8, ["modelValue", "id"]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", null, _toDisplayString(label.value), 1)
      ])
    ]),
    _: 3
  }, 8, ["for", "class"]))
}
}

})